import { TApplicationState } from 'shared/types/redux';

export const sellersSelector = (state: TApplicationState) => {
  return state.newbuilding.sellers;
};

export function sellersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers.filter(seller => seller.showPhone && seller.phone);
  }

  return [];
}
